import React from 'react';

import { TAB_MIN_WIDTH } from '../../../shared/constants';
import { addModifiers } from '../../../shared/helpers';
import { isMobile } from '../../../shared/helpers/responsive';

const smallTabWidth = 170;

interface EditorTabElementProps {
  tabName: string;
  tabNumber?: number | null;
  tabWidth?: number;
  active?: boolean;
  multi?: boolean;
  isSuperAlpha?: boolean;
  progress: number;
  tabElementClass: string;
  currentTabWidth: number;
  tabNameOverflowed?: boolean;
  onActivateClickHandler?: (event: any) => void;
  onCloseClickHandler?: (event: React.SyntheticEvent<HTMLSpanElement>) => void;
  handleRenameTab?: (e: any) => void;
  handleDisableRename?: (e: any) => void;
  disableRename?: (e: any) => void;
  canRename: boolean;
  isChild: boolean;
  tabStatus: string | undefined;
  isDropdownMenu?: boolean;
  handleChildDropdownMenu?: (event: any) => void;
  isChildDropdownMenuOpen?: boolean;
  tabHovered?: boolean;
}

const EditorTabInsideElement = ({
  tabName,
  tabNumber,
  tabWidth = 200,
  active = false,
  multi,
  isSuperAlpha,
  progress,
  tabElementClass,
  currentTabWidth,
  tabNameOverflowed = false,
  onActivateClickHandler,
  onCloseClickHandler,
  handleRenameTab,
  handleDisableRename,
  disableRename,
  canRename,
  isChild,
  tabStatus,
  isDropdownMenu = false,
  handleChildDropdownMenu,
  isChildDropdownMenuOpen = false,
  tabHovered = false,
}: EditorTabElementProps): JSX.Element => {
  let tabElementTextModifiers: any = [];
  tabElementTextModifiers = active ? tabElementTextModifiers.concat(['active']) : tabElementTextModifiers;

  let multiplier;
  if (multi || isSuperAlpha) {
    multiplier = active || currentTabWidth > smallTabWidth ? 0.55 : 0.45;
  } else {
    multiplier = isChild ? 0.7 : 0.45;
  }
  const inactiveTabTextMaxWidth = currentTabWidth >= TAB_MIN_WIDTH ? multiplier * currentTabWidth : multiplier * 110;
  const isMultiModifier = multi ? ['multi'] : [];
  const progressWidth = `${progress * 100}%`;

  let dotColorModifiers: any = [];
  dotColorModifiers = tabStatus ? dotColorModifiers.concat([tabStatus]) : dotColorModifiers;
  // Modifiers for Dropdown
  tabElementTextModifiers = isDropdownMenu ? tabElementTextModifiers.concat(['dropdown-element', tabStatus]) : tabElementTextModifiers;
  dotColorModifiers = isDropdownMenu ? dotColorModifiers.concat(['dropdown-element']) : dotColorModifiers;

  return (
    <div className="editor-tabs__tab-inside-element" onClick={onActivateClickHandler}>
      {!isChild && (
        <React.Fragment>
          <span className={`${tabElementClass}-progress`} style={{ width: progressWidth }} />
          <span
            className={
              'editor-tabs__tab-inside-element__alpha-icon' +
              `${multi ? ' multi-simulation' : isSuperAlpha ? ' super-alpha-simulation' : ''}${active ? ' active-tab' : ''}`
            }
          />
        </React.Fragment>
      )}
      {canRename ? (
        <input
          onBlur={handleDisableRename}
          onChange={handleRenameTab}
          onKeyPress={disableRename}
          disabled={!canRename}
          className={addModifiers('editor-tabs__tab-text', tabElementTextModifiers)}
          value={tabName}
        />
      ) : tabNameOverflowed && !isMobile('mobile') ? (
        <div style={{ display: 'flex', maxWidth: `${inactiveTabTextMaxWidth}px` }}>
          <div className={`${addModifiers('editor-tabs__tab-text', tabElementTextModifiers)} tab-text-overflowed`}>{tabName}</div>
          <div className="editor-tabs__tab-text-id">{tabNumber}</div>
        </div>
      ) : (
        <div className={addModifiers('editor-tabs__tab-text', tabElementTextModifiers)}>{tabName}</div>
      )}
      {!isDropdownMenu ? (
        <React.Fragment>
          <span className={addModifiers('editor-tabs__tab-dot', dotColorModifiers)} />
          {(isMobile('mobile') || tabWidth > smallTabWidth || active) && (
            <span className={addModifiers('editor-tabs__tab-cross', isMultiModifier)} onClick={onCloseClickHandler} />
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {multi && !isChild && (
            <div className="editor-tabs__tab-dropdown" onClick={handleChildDropdownMenu}>
              <span className={`editor-tabs__tab-dropdown__arrow${isChildDropdownMenuOpen ? '--open' : '--closed'}`} />
            </div>
          )}
          {active || tabHovered ? (
            <span className={addModifiers('editor-tabs__tab-cross', ['dropdown-element', 'active'])} onClick={onCloseClickHandler} />
          ) : (
            <span className={addModifiers('editor-tabs__tab-dot', dotColorModifiers)} />
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default EditorTabInsideElement;
